var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570",
    transform: "translate(-1148 -340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7322",
    "data-name": "Path 7322",
    d: "M12.554,52.978v5.209L11.047,59.7,2,50.638l1.507-1.51h5.2Z",
    transform: "translate(1146.375 300.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7323",
    "data-name": "Path 7323",
    d: "M14.532,40.4l6.079-4.982a6.043,6.043,0,0,0,2.212-4.674V29.076H21.158a6.027,6.027,0,0,0-4.667,2.215L11.517,37.38,10.01,39.645l2.261,2.265Z",
    transform: "translate(1139.875 316.397)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7324",
    "data-name": "Path 7324",
    d: "M167.209,11.56V5.521a1.509,1.509,0,0,0-1.507-1.51h-7.537V10.05H165.7a1.51,1.51,0,0,1,0,3.02",
    transform: "translate(1019.607 336.744)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7325",
    "data-name": "Path 7325",
    d: "M59.567,41.862a.754.754,0,1,1-.754-.755.754.754,0,0,1,.754.755",
    transform: "translate(1100.869 306.631)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7326",
    "data-name": "Path 7326",
    d: "M.754,61.419a.755.755,0,0,1-.533-1.289l.754-.755A.754.754,0,1,1,2.04,60.443l-.754.755a.751.751,0,0,1-.533.221",
    transform: "translate(1148 291.98)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    d: "M36.791,97.514a.755.755,0,0,1-.533-1.289l.754-.755a.754.754,0,1,1,1.066,1.068l-.754.755a.751.751,0,0,1-.533.221",
    transform: "translate(1118.746 262.68)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M31.538,202.283a.754.754,0,1,1-.754-.755.754.754,0,0,1,.754.755",
    transform: "translate(1123.621 176.407)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M15.522,186.241a.754.754,0,1,1-.754-.755.754.754,0,0,1,.754.755",
    transform: "translate(1136.623 189.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M39.547,162.178a.754.754,0,1,1-.754-.755.755.755,0,0,1,.754.755",
    transform: "translate(1117.121 208.962)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M202.728,12.031h3.015l-3.015,3.775,3.015,3.774h-7.537l1.094-.637.207-.353.206-.373V12.031Z",
    transform: "translate(987.104 330.233)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7332",
    "data-name": "Path 7332",
    d: "M135.491,112.236c-.121.217-.243.43-.365.638a67.31,67.31,0,0,1-10.176,12.651,67.248,67.248,0,0,1-12.631,10.193c-.6.352-1.235.7-1.886,1.022a18.252,18.252,0,0,0,25.058-24.5",
    transform: "translate(1058.354 248.891)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M71.8,83.988a.755.755,0,0,1,0,1.067l-6.068,6.077c-.018.018-.033.036-.051.054a18.335,18.335,0,0,0,3.375,3.085C72.591,92.727,77.988,89,84.022,82.956a65.8,65.8,0,0,0,9.943-12.349c.26-.443.517-.91.758-1.384a18.347,18.347,0,0,0-3.7-4.064c-.023.022-.045.043-.068.066a.753.753,0,0,1-1.145-.97,18.114,18.114,0,0,0-9.5-3.143v8.314a.754.754,0,1,1-1.508,0V61.11A18.272,18.272,0,0,0,61.61,82.556l9.124-9.136A.754.754,0,0,1,71.8,74.488l-9.476,9.491a.745.745,0,0,1-.349.2,17.834,17.834,0,0,0,.944,2.637L76,73.425a.754.754,0,1,1,1.076,1.057L63.8,88.07a.8.8,0,0,1-.185.138,17.468,17.468,0,0,0,1.126,1.779l5.99-6a.752.752,0,0,1,1.066,0",
    transform: "translate(1098.215 290.393)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7334",
    "data-name": "Path 7334",
    d: "M218.647,68.073c.788.789.008,3.118-1.1,5.3q.488.732.906,1.511c1.569-2.816,2.895-6.247,1.265-7.88-.839-.841-4.048-1.661-7.006,1.3a.758.758,0,0,0-.079.1q.626.427,1.213.9c2.376-2.321,4.591-1.442,4.807-1.237",
    transform: "translate(975.396 286.242)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    "data-name": "Path 7335",
    d: "M72.35,219.651a1.884,1.884,0,0,1-.481-1.232,3.323,3.323,0,0,1,1.143-2.361l0,0,0,0A.752.752,0,0,1,72,214.936a4.769,4.769,0,0,0-1.635,3.533,3.377,3.377,0,0,0,.922,2.25,2.8,2.8,0,0,0,2.067.747,11.215,11.215,0,0,0,4.552-1.358q-.784-.446-1.516-.965c-2.056.9-3.484,1.062-4.037.508",
    transform: "translate(1090.885 165.522)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M118.409,119.008a67.318,67.318,0,0,0,10.176-12.651c.122-.208.244-.422.365-.638q-.417-.779-.906-1.511c-.242.474-.5.941-.759,1.384a65.8,65.8,0,0,1-9.943,12.349c-6.034,6.044-11.432,9.771-14.967,11.317q.733.518,1.517.965c.65-.319,1.288-.669,1.886-1.022a67.249,67.249,0,0,0,12.631-10.193",
    transform: "translate(1064.895 255.408)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M84.412,220.654l0,0,0,0c.018-.018.033-.036.051-.054-.018.018-.038.031-.057.047",
    transform: "translate(1079.477 160.919)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7338",
    "data-name": "Path 7338",
    d: "M212.1,78.779a.752.752,0,0,0,1.066,0l.068-.066q-.587-.477-1.213-.9a.754.754,0,0,0,.079.97",
    transform: "translate(976.002 276.837)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M73.009,126.619a.754.754,0,0,0-1.065-1.068l-9.124,9.136c.1.549.219,1.091.364,1.621a.746.746,0,0,0,.349-.2Z",
    transform: "translate(1097.004 238.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M83.93,126.613a.754.754,0,1,0-1.076-1.057L69.768,138.945v0c.213.476.445.94.7,1.393a.8.8,0,0,0,.185-.138Z",
    transform: "translate(1091.365 238.262)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    d: "M79.132,214.522h0l-.078.078a.73.73,0,0,1,.084-.069l-.006-.008",
    transform: "translate(1083.826 165.858)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    d: "M79.474,187.705a.753.753,0,0,1,.981,1.137l6.067-6.077a.754.754,0,0,0-1.066-1.067l-5.99,6h0l.006.008",
    transform: "translate(1083.492 192.685)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M78.1,215.706a.745.745,0,0,0,1.009.047c-.325-.382-.635-.776-.924-1.183a.729.729,0,0,0-.084.069.756.756,0,0,0,0,1.067",
    transform: "translate(1084.779 165.82)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M80.483,213.989a.75.75,0,0,0-.981-.069c.29.408.6.8.924,1.183.019-.016.039-.029.057-.047a.756.756,0,0,0,0-1.067",
    transform: "translate(1083.463 166.469)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M155.667,12.824V.755a.754.754,0,1,0-1.507,0V12.824c.25-.01.5-.017.753-.017s.5.007.755.017",
    transform: "translate(1022.857 340)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M154.914,70.106a.754.754,0,0,0,.754-.755V61.038c-.25-.01-.5-.017-.754-.017s-.5.006-.753.017v8.313a.754.754,0,0,0,.754.755",
    transform: "translate(1022.857 290.465)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 48,
    height: 48,
    transform: "translate(1148 340)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium-plan.5cecb16b197bb46d31d04b8c5c829651.svg";
export { ForwardRef as ReactComponent };